/// <amd-module name="Environments/Providers/Kubernetes/EditKubernetesResourcePanel" />
import { KubernetesResource, ServiceEndpoint } from "Environments/Providers/Kubernetes/Generated/TaskAgentContracts/TaskAgent";
import * as Resources from "Environments/Providers/Kubernetes/Resources";
import * as React from "react";
import { VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

export interface IEditKubernetesResourcePanelProps {
    resource: KubernetesResource;
    environmentId: number;
    environmentName: string;
    endpoint: ServiceEndpoint;
    onClose: () => void;
    onEditComplete: () => void;
}

export class EditKubernetesResourcePanel extends VssComponent<IEditKubernetesResourcePanelProps>{
    public render(): React.ReactNode {
        const resourceProps = {
            onResourceCreated: () => {
                this.props.onEditComplete();
                this.props.onClose();
            },
            onDismissPanel: () => this.props.onClose(),
            resourceType: 4 /* EnvironmentResourceType.Kubernetes */,
            resource: this.props.resource,
            properties: { endpoint: this.props.endpoint },
            instanceId: "edit-k8s-resource-" + this.props.resource.id,
            environmentId: this.props.environmentId,
            environmentName: this.props.environmentName
        };

        const spinLoader = <Spinner label={Resources.Loading} size={SpinnerSize.large} className="absolute-fill" />;
        return (
            <WrappedComponent
                wrappedType={"editResources"}
                wrappedProps={resourceProps}
                dependencies={["ms.vss-environments-web.environments-create-panel"]}
                className="flex-grow justify-center"
                loadingComponent={() => spinLoader}
            />
        );
    }
}